import { render, staticRenderFns } from "./CertificateOfCurrency.vue?vue&type=template&id=5a7d766c&scoped=true&"
import script from "./CertificateOfCurrency.vue?vue&type=script&lang=js&"
export * from "./CertificateOfCurrency.vue?vue&type=script&lang=js&"
import style0 from "./CertificateOfCurrency.vue?vue&type=style&index=0&id=5a7d766c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d766c",
  null
  
)

export default component.exports